import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {logout} from 'api';
import {Notice} from 'ui';

export default function Logout() {
  const history = useHistory();
  useEffect(() => {
    logout();
    history.replace('/');
  }, [history]);
  return <Notice text="Logging out..."/>;
}